// extracted by mini-css-extract-plugin
export default {"submitContainer":"SubmitSection_submitContainer__EqvRN"};